/**
 * Component Registry for AI File Description
 *
 * This registry maps organization + tag combinations to specific UI components.
 * Each entry defines when a particular component should be rendered based on:
 * - Organization ID (srcOrgId and/or dstOrgId)
 * - Tags present in the issue
 * - Additional conditions
 */

// Import layout components
import {
  DefaultLayout,
  NIDCInboundLayout,
  NIDCCheckupLayout,
} from '../layouts';

/**
 * Simple component lookup registry
 *
 * Maps organizationCode + tagName combinations to components
 * Format: "organizationCode|tagName" -> Component
 */
const COMPONENT_LOOKUP = {
  'NIDC|inbound': NIDCInboundLayout,
  'NIDC|checkup': NIDCCheckupLayout,

  'HosA|inbound': NIDCInboundLayout,
  'HosA|checkup': NIDCCheckupLayout,

  'ClcB|inbound': NIDCInboundLayout,
  'ClcB|checkup': NIDCCheckupLayout,

  'HosE|inbound': NIDCInboundLayout,
  'HosE|checkup': NIDCCheckupLayout,

  'HosX|inbound': NIDCInboundLayout,
  'HosX|checkup': NIDCCheckupLayout,

  'HosY|inbound': NIDCInboundLayout,
  'HosY|checkup': NIDCCheckupLayout,

  'HosZ|inbound': NIDCInboundLayout,
  'HosZ|checkup': NIDCCheckupLayout,

  'HosI|inbound': NIDCInboundLayout,
  'HosI|checkup': NIDCCheckupLayout,

  'HosD|inbound': NIDCInboundLayout,
  'HosD|checkup': NIDCCheckupLayout,

  'iwg_support|inbound': NIDCInboundLayout,
  'iwg_support|checkup': NIDCCheckupLayout,

  'iwg_test|inbound': NIDCInboundLayout,
  'iwg_test|checkup': NIDCCheckupLayout,

  // Add more combinations as needed:
  // 'OtherOrg|sometag': SomeOtherLayout,
};

/**
 * Resolves the appropriate component for given issue and organization context
 *
 * @param {Object} issue - The issue object containing tags and organization info
 * @param {string} currentOrganizationId - Current user's organization ID
 * @returns {React.Component} The component to render
 */
export function resolveComponent({ issue, currentOrganizationId: _ }) {
  const orgCode = issue.dstOrg?.organizationCode;

  // Find first matching tag and return corresponding component
  if (orgCode && issue.tags) {
    for (const tag of issue.tags) {
      const tagName = (tag?.name || tag)?.toLowerCase?.();
      if (tagName) {
        const lookupKey = `${orgCode}|${tagName}`;
        const component = COMPONENT_LOOKUP[lookupKey];

        if (component) {
          console.log(`Using AI layout for: ${orgCode} + ${tagName}`);
          return component;
        }
      }
    }
  }

  // Default fallback
  console.log('Using default AI layout');
  return DefaultLayout;
}

export default {
  resolveComponent,
  COMPONENT_LOOKUP,
};
